<template>
  <div class="border rounded border-secondary p-1">
    <div class="mb-1">
      <!--      <b-form-select id="input-default" v-model="mode" :options="modes" @change="onChangeMode" />-->
      <div style="display: flex; align-items: center;">
        <b-form-radio
          v-model="mode"
          style="cursor: pointer;"
          plain
          name="json"
          value="json"
          @change="onChangeMode"
        >
          JSON
        </b-form-radio>
        <b-form-radio
          v-model="mode"
          class="ml-2"
          style="cursor: pointer;"
          plain
          name="string"
          value="string"
          @change="onChangeMode"
        >
          String
        </b-form-radio>
      </div>
    </div>
    <cbs-json-object
      v-if="mode === 'json' && valueType() === 'object'"
      :value="value"
      :name="'ROOT'"
    />
    <div v-if="mode === 'string'">
      <b-form-textarea
        v-model="strValue"
        placeholder="Textarea"
        rows="3"
      />
    </div>
    <cbs-debug :context="this" />
  </div>
</template>

<script>
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import CbsJsonObject from '@/cubus/components/json-editor/CbsJsonObject.vue'
import { BFormRadio, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'CbsJsonEditor',
  components: {
    BFormTextarea,
    CbsJsonObject,
    CbsDebug,
    BFormRadio,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      newTitle: null,
      mode: 'json', // 'json' or 'string'
      modes: ['json', 'string'],
      strValue: null,
    }
  },
  methods: {
    clearTitle() {
      this.newTitle = null
    },
    addString() {
      this.$set(this.value, this.newTitle, null)
      this.clearTitle()
    },
    addObject() {
      this.$set(this.value, this.newTitle, {})
      this.clearTitle()
    },
    addArray() {
      this.$set(this.value, this.newTitle, [])
      this.clearTitle()
    },
    attrType(key) {
      console.log('key', key)
      console.log('attr', this.value[key])
      const attr = this.value[key]
      if (attr instanceof Array) return 'array'
      if (attr === null) return 'field'
      return typeof this.value[key]
    },
    valueType() {
      if (this.value instanceof Array) return 'array'
      if (this.value === null) return 'field'
      return typeof this.value
    },
    onChangeMode() {
      console.log('onChangeMode', this.mode)
      if (this.mode === 'string') {
        this.strValue = JSON.stringify(this.value)
      } else {
        // console.log('strValue', this.strValue)
        try {
          const jo = JSON.parse(this.strValue)
          // console.log('jo', JSON.stringify(jo))
          for (const key in this.value) {
            if (this.value.hasOwnProperty(key)) {
              this.$delete(this.value, key)
            }
          }
          // добавить атрибуты jo в this.value
          for (const key in jo) {
            if (jo.hasOwnProperty(key)) {
              this.$set(this.value, key, jo[key])
            }
          }
        } catch (e) {
          console.error('Invalid JSON string:', e)
          this.$bvToast.toast('Invalid JSON string', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.mode = 'string'
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
